import React, { Component, PropTypes } from 'react'
import LivreForAuteur from './LivreForAuteur'
import OrderByBox from '../../shared/orderbybox'

let orderChoices = [
	{field: 'star',  'label': 'Etoiles'},
	{field: 'titrelivre',  'label': 'Titre'},
	{field: 'nbr',  'label': '# Crit.'},
	{field: 'cdate', 'label': 'Date'},
	{field: 'pseudo', 'label': 'Lecteur'}
]
	

class LivresList extends Component {
	constructor(props){
		super(props);
		this.renderHeader = this.renderHeader.bind(this);
		this._sort = this._sort.bind(this);

	}

	_sort(field){
		//console.log(col);
		this.props.handleSort(field);
	}
	
	renderHeader(){

    	let nbrLivres = this.props.livres.length;
    	if (nbrLivres > 1 && this.props.handleSort){
    		return (
    				<OrderByBox choices={orderChoices} handleOrderBy={this._sort} sort={this.props.sort} />       			
    		)
    	} else {
    		return 
    	}
    }

    render(){
	
		return (
			<div>
				{this.renderHeader()}
				<ul className="media-list">
					{this.props.livres.map((el,idx)=>{
						return (
							<li key={idx} className="media">
								<LivreForAuteur {...el} />
							</li>)
						})
					}
				</ul>
			</div>
		)
	}
}

LivresList.propTypes = {
	'sort' : PropTypes.shape({
		'field' : PropTypes.string,
		'dir' : PropTypes.string
	}),
	'livres' : PropTypes.arrayOf(PropTypes.shape),
	'handleSort' : PropTypes.func
}

export default LivresList


// WEBPACK FOOTER //
// ./auteur/livres/livreslist.js